import React, {useEffect, useState} from 'react';
import css from './VacancyHead.module.scss';
import {useRouter} from 'next/router';
import {VacancyCard, VacancyCardProps} from 'COMPONENTS/pages-components/common/VacancyCard/VacancyCard';
import {classNames} from 'a-utils';
import {Select} from 'COMPONENTS/pages-components/common/Select/Select';
import {getData} from '../../../../pages/api/mocks/vacancies/items';
import {JustLink} from 'TYPES/types';
import Link from 'next/link';
import { motion } from 'framer-motion';
import {SquirrelVideo} from 'COMPONENTS/pages-components/common/SquirrelVideo/SquirrelVideo';


export type detailVacancyProps = {
	title: string,
  filters: FilterType;
  items: VacancyCardProps[],
  moreText?: string;
  isEnd?: boolean;
  url?: string;
};

type FilterType = {
  sortBy?: string;
  firstFilterLinks?: filterLink[]
  secondFilterLinks?: filterLink[]
  resetBtn: JustLink;
}

export type filterLink = JustLink & {
  filterText: string;
}

export type CardResponse = {
  moreText?: string;
  isEnd?: boolean;
  items?: VacancyCardProps[];
}


export const VacancyHead = ({title, filters, items = [], isEnd, url, moreText  }: detailVacancyProps) => {


  return (
    <></>
  );
};
